/* ══════════════════════════════════════════════════════════════════════════
   gaela-h2.js — las entradas de la home 2.

   🔴 SIN ESTE SCRIPT LA PÁGINA SE VE ENTERA. La animación no la enciende el
   CSS: la enciende ESTA línea, que marca `<html>` con `gf-h2-anima`. Si el
   script no carga, no falla, no se retrasa y no hay nada invisible esperando
   a un observador que nunca llegará — que es el fallo de A-024 y el que dejó
   la línea de tiempo de la ficha apagada.

   🔴 Y SI ALGUIEN PIDE MENOS MOVIMIENTO, no se marca nada: el CSS ya no tiene
   a quién animar. Una sola comprobación, y no hace falta repetirla en cada
   regla.

   ⚠️ El observador NO desobserva. Al volver a subir, la pieza vuelve a entrar:
   es una página que se recorre en los dos sentidos.
   ⚠️ `rootMargin` negativo por abajo: la pieza entra cuando ya está DENTRO de
   la pantalla, no cuando asoma un píxel por el borde.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  var reducido = matchMedia('(prefers-reduced-motion: reduce)');
  if (reducido.matches) return;
  if (typeof IntersectionObserver !== 'function') return;

  var raiz = document.documentElement;
  raiz.classList.add('gf-h2-anima');

  function mirar() {
    var piezas = document.querySelectorAll('[data-gf-h2-entra]:not([data-gf-h2-visto])');
    if (!piezas.length) return;

    var ojo = new IntersectionObserver(
      function (lista) {
        lista.forEach(function (e) {
          e.target.classList.toggle('gf-h2--dentro', e.isIntersecting);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    [].forEach.call(piezas, function (p) {
      p.setAttribute('data-gf-h2-visto', '');
      ojo.observe(p);
    });
  }

  mirar();

  /* El personalizador reemplaza el nodo de la sección al retocarla: lo que se
     estaba observando deja de existir y la pieza nueva nace sin observador. */
  document.addEventListener('shopify:section:load', mirar);

  /* Si alguien cambia la preferencia con la página abierta, se deja de animar
     y todo se queda visible: quitar la marca basta, el CSS hace el resto. */
  reducido.addEventListener('change', function (e) {
    if (e.matches) raiz.classList.remove('gf-h2-anima');
  });
})();
